/*
 ## External Dependencies ##
 - agendor-web/public_html/src/javascript/globals/util.js -> to use function setCookie
 */

var Reflux = require("reflux");
var ListingActions = require("app/shared/actions/listing-actions");
var _ = require("underscore");
var LOGGED_USER_ID = window.loggedUserId;
var MORE_FILTERS = ["origemLead", "dii", "dif", "forgotten"];

var moment = require("moment");

var ListingStore = Reflux.createStore({
  state: {
    env: "organization", //organization, person, deal
    subEnv: null,//pipeline, salesMap
    persistedFiltersCookieName: "listingFilters",
    persistedOrderByCookieName: "listingFiltersOrderBy",
    daysToPersistCookies: 7,
    totalResults: 0,
    dealsTotalValue: 0,
    qpp: 25,
    pg: 0,
    inspirationalQuote: {quote:"", author:""},
    orderBy: {
      value: "6",
      options: {
        organization: [
          {value:"1", label:"Ranking maior - menor"},
          {value:"2", label:"Ranking menor - maior"},
          {value:"5", label:"Ordem alfabética"},
          {value:"6", label:"Data de cadastro recente - antigo"},
          {value:"7", label:"Data de cadastro antigo - recente"},
          {value:"10", label:"Atualização recente - antiga"},
          {value:"11", label:"Atualização antiga - recente"}
        ],
        person: [
          {value:"1", label:"Ranking maior - menor"},
          {value:"2", label:"Ranking menor - maior"},
          {value:"5", label:"Ordem alfabética"},
          {value:"6", label:"Data de cadastro recente - antigo"},
          {value:"7", label:"Data de cadastro antigo - recente"},
          {value:"10", label:"Atualização recente - antiga"},
          {value:"11", label:"Atualização antiga - recente"}
        ],
        deal: [
          {value:"1", label:"Ranking maior - menor"},
          {value:"2", label:"Ranking menor - maior"},
          {value:"3", label:"Etapa maior - menor"},
          {value:"4", label:"Etapa menor - maior"},
          {value:"5", label:"Ordem alfabética"},
          {value:"6", label:"Data de cadastro recente - antigo"},
          {value:"7", label:"Data de cadastro antigo - recente"},
          {value:"8", label:"Atualização recente - antiga"},
          {value:"13", label:"Atualização antiga - recente"},
          {value:"9", label:"Data de conclusão distante - próxima"},
          {value:"10", label:"Data de conclusão próxima - distante"},
          {value:"11", label:"Valor maior - menor"},
          {value:"12", label:"Valor menor - maior"}
        ]
      }
    },
    selects: {
      ct: {
        name: "ct",
        resource: "categories",
        defaultLabel: "Categoria",
        options: [{id:"", name:"Categoria"}],
        extraOptions: [{id:"-1", name:"Indefinida"}]
      },
      st: {
        name: "st",
        resource: "sectors",
        defaultLabel: "Setor",
        options: [{id:"", name:"Setor"}],
        extraOptions: [{id:"-1", name:"Indefinido"}]
      },
      funil: {
        name: "funil",
        resource: "funnels",
        defaultLabel: "Funil",
        options: [{id:"", name:"Funil"}]
      },
      et: {
        name: "et",
        resource: "deal_stages",
        defaultLabel: "Etapa",
        options: [{id:"", name:"Etapa"}],
        extraOptions: [{id:"-1", name:"Indefinida"}]
      },
      sn: {
        name: "sn",
        resource: null,
        defaultLabel: "Status",
        options: [
          {id:"", name:"Status"},
          {id:"1", name:"Em andamento"},
          {id:"2", name:"Ganho"},
          {id:"3", name:"Perdido"}
        ]
      },
      mp: {
        name: "mp",
        resource: "loss_reasons",
        defaultLabel: "Motivo de perda",
        options: [{id: "", name: "Motivo de perda"}],
        extraOptions: [{id: "-1", name: "Indefinido"}]
      },
      ur: {
        name: "ur",
        resource: "users",
        defaultLabel: "Responsável",
        options: [{id:"", name:"Responsável"}],
        extraOptions: [{id:"-1", name:"Indefinido"}]
      },
      origemLead: {
        name: "origemLead",
        resource: "lead_origins",
        defaultLabel: "Origem",
        options: [{id:"", name:"Origem"}],
        extraOptions: [{id:"-1", name:"Indefinido"}]
      },
      forgotten: {
        name: "forgotten",
        resource: "forgotten",
        defaultLabel: "Esquecidos",
        options: [
          {id: "", name: "Esquecidos"},
          {id: "noActivity", name: "Nunca trabalhados (histórico vazio)"},
          {id: "noRecentActivity", name: "Última atividade há mais de 30 dias"},
          {id: "noFutureTasks", name: "Sem atividades agendadas"},
          {id: "delayedTasks", name: "Com atividades atrasadas"}
        ]
      },
      team: {
        name: "team",
        resource: "teams",
        defaultLabel: "Equipes",
        options: [
          {id: "", name: "Equipes"}
        ]
      },
      e: {
        name: "e",
        resource: null,
        defaultLabel: "Estado",
        options: [
          {id:"", name:"Estado"},
          {id:"AC", name:"AC"},
          {id:"AL", name:"AL"},
          {id:"AP", name:"AP"},
          {id:"AM", name:"AM"},
          {id:"BA", name:"BA"},
          {id:"CE", name:"CE"},
          {id:"DF", name:"DF"},
          {id:"ES", name:"ES"},
          {id:"GO", name:"GO"},
          {id:"MA", name:"MA"},
          {id:"MT", name:"MT"},
          {id:"MS", name:"MS"},
          {id:"MG", name:"MG"},
          {id:"PA", name:"PA"},
          {id:"PB", name:"PB"},
          {id:"PR", name:"PR"},
          {id:"PE", name:"PE"},
          {id:"PI", name:"PI"},
          {id:"RJ", name:"RJ"},
          {id:"RN", name:"RN"},
          {id:"RS", name:"RS"},
          {id:"RO", name:"RO"},
          {id:"RR", name:"RR"},
          {id:"SC", name:"SC"},
          {id:"SP", name:"SP"},
          {id:"SE", name:"SE"},
          {id:"TO",name:"TO"}
        ]
      },
      u: {
        name: "u",
        resource: null,
        defaultLabel: "Usuário",
        options: [{id:"", name:"Usuário"}]
      },
      fi: {
        name: "fi",
        resource: null,
        defaultLabel: "Funil inicial",
        options: [{id:"", name:"Funil inicial"}]
      }
    },
    dates: {
      dci: {
        label: "Conclusão de"
      },
      dcf: {
        label: "Conclusão até"
      },
      dii: {
        label: "Início de"
      },
      dif: {
        label: "Início até"
      }
    },
    filters: {
      organization: ["q","ct","st","e","c","b","ur","cnpj","pro", "origemLead", "forgotten", "team", "moreFilters"],
      person: ["q","ct","em","ca","e","c","b","ur","pro", "origemLead", "forgotten", "team", "moreFilters"],
      deal: ["q","em","p","sn", "mp","ur", "e", "dc", "dci", "dcf", "di", "dii", "dif", "funil", "et", "pro", "origemLead", "forgotten", "team", "frozen", "u", "fi", "moreFilters"]
    },
    filterValues: {
      q: {},
      em: {},
      p: {},
      ca: {},
      ct: {},
      st: {},
      sn: {},
      mp: {},
      e: {},
      c: {},
      b: {},
      ur: {},
      dc: {},
      dci: {},
      dcf: {},
      di: {},
      dii: {},
      dif: {},
      funil: {},
      et: {},
      cnpj: {},
      pro: {},
      origemLead: {},
      forgotten: {},
      team: {},
      frozen: {
        value: 1,
        hide: true,
        preventRemoval: true
      },
      u: {},
      fi: {},
      moreFilters: {
        name: "moreFilters",
        quantity: 0,
        opened: false,
        highlighted: false
      }
    }
  },
  // listenables: ListingActions,
  init: function(){
    this.listenTo(ListingActions.applyFilter, this.onApplyFilter);
    this.listenTo(ListingActions.removeAllFilters, this.onRemoveAllFilters);
    this.listenTo(ListingActions.removeFilter, this.onRemoveFilter);
    this.listenTo(ListingActions.orderBy, this.onOrderBy);
    this.listenTo(ListingActions.updateTotalResults, this.onUpdateTotalResults);
    this.listenTo(ListingActions.updatePage, this.onUpdatePage);
    this.listenTo(ListingActions.updateDealsTotalValue, this.onUpdateDealsTotalValue);
    this.listenTo(ListingActions.highlightFilter, this.onHighlightFilter);
    this.listenTo(ListingActions.diminishFilters, this.onDiminishFilters);
    this.listenTo(ListingActions.loadSelectOptions.completed, this.onLoadSelectOptionsCompleted);
    this.listenTo(ListingActions.loadFunnelOptions.completed, this.onLoadFunnelOptionsCompleted);
    this.listenTo(ListingActions.loadDealStageOptions.completed, this.onLoadDealStageOptionsCompleted);
    this.listenTo(ListingActions.loadUserOwnerOptions.completed, this.onLoadUserOwnerOptionsCompleted);
    this.listenTo(ListingActions.loadLeadOriginOptions.completed, this.onLoadLeadOriginOptionsCompleted);
    this.listenTo(ListingActions.loadProducts.completed, this.onLoadProductsCompleted);
    this.listenTo(ListingActions.loadQuote.completed, this.onLoadQuoteCompleted);
    this.listenTo(ListingActions.handleMoreFiltersClick, this.onMoreFiltersClick);
    this.listenTo(ListingActions.handleFilterOverrides, this.onHandleFilterOverrides);

    this.state = this.getDefaultData();
  },
    // this will be called by all listening components as they register their listeners
  getDefaultData: function(overrides) {
    this.state.env = this.getEnv();
    this.state.subEnv = this.getSubEnv();
    var filters = this.getQueryStringFilters() || this.getPersistedFilters();
    for (var key in filters[this.state.env]) {
      this.state.filterValues[key] = filters[this.state.env][key];
    }

    var defaultOrderBy = this.state.orderBy.value;
    this.state.orderBy.value = this.getPersistedOrderByValue() || defaultOrderBy;

    overrides = overrides || {};
    for (var key in overrides) {
      this.state.filterValues[key] = overrides[key];
    }

    return this.state;
  },
  getCurrentPageName: function () {
    return window.location.pathname.split("/")[2];
  },
  getCurrentPageViewMode: function () {
    if (window.location.pathname.split("/")[3]) {
      return window.location.pathname.split("/")[3].split(".")[0];
    } else {
      return null;
    }
  },
  getEnv: function(){
    switch(this.getCurrentPageName()){
      case "pessoas": return "person"; break;
      case "empresas": return "organization"; break;
      case "negocios": return "deal"; break;
      default: return "organization"; break;
    }
  },
  getSubEnv: function(){
    switch(this.getCurrentPageViewMode()){
      case "funil": return "pipeline"; break;
      case "mapa": return "salesMap"; break;
      case "negocios": return "deal"; break;
      case "pessoas": return "person"; break;
      default: return null; break;
    }
  },
  setState: function(newState){
    this.state = newState;
    this.trigger(this.state); // sends the updated list to all listening components
  },
  updateListing: function(){
    switch(this.state.env){
      case "organization": EmpresaUI.listar(false); break;
      case "person": PessoaUI.listar(false); break;
      case "deal":
        switch(this.state.subEnv){
          case "pipeline":
            if (FunilUI.loaded) {
              FunilUI.refresh()
            }
          break;
          case "salesMap":
            if (MapaVendasUI.loaded) {
              MapaVendasUI.refresh();
            }
          break;
          default: NegocioUI.listar(false); break;
        }
        break;
    }
  },
  getQueryStringFilters: function(){
    var query = window.location.search.substring(1); // delete "?"
    if (!query) {
      return false;
    }
    var queryStringObject = _.chain(query.split('&'))
      .map(function(params) {
        var p = params.split('=');
        return [p[0], decodeURIComponent(p[1])];
      }).object()
      .value();

    return this.convertToFilter(queryStringObject);
  },
  convertToFilter: function(object){
    var filter = {};
    filter[this.state.env] = {};
    _.each(object, function(value, key) {
      if (this.state.filters[this.state.env].indexOf(key) > -1) {
        if (key == "pro") {
          // When it's a product, we need to have an entry in "pro" to set the
          // hidden input value and another one in "pro123" (where 123 is the id)
          // to display the label.
          // The first one won't be displayed because it doesn't have a name prop.
          filter[this.state.env][key] = { value };
          key = key + value;
        }

        filter[this.state.env][key] = {
          "value": value,
          "name": key,
          "label": this.getLabelForFilter(key, value)
        };

        if(filter[this.state.env]["moreFilters"] == undefined && MORE_FILTERS.indexOf(key) > -1) {
          filter[this.state.env]["moreFilters"] = {opened: true}
        }
      }
    }.bind(this));
    return filter;
  },
  getLabelForFilter: function(key, value) {
    let relatedSelect = this.state.selects[key];
    if (relatedSelect)
      return this.getLabelForSelect(relatedSelect, value);

    let relatedDate = this.state.dates[key];
    if (relatedDate)
      return this.getLabelForDatePicker(relatedDate, value);

    if (key.startsWith("pro")) {
      // It's hard to support products right now because the store is in Produto.js
      // and it seems not to be loaded at this point.
      return "Produto";
    }

    return value;
  },
  getLabelForSelect: function(select, value) {
    let allOptions = select.options.concat(select.extraOptions || []);
    let option = allOptions.find(({ id }) => id == value);

    return option && option.name || select.defaultLabel;
  },
  getLabelForDatePicker: function(datePicker, value) {
    let formattedDate = moment(value).format("DD/MM/YYYY");

    return `${datePicker.label}: ${formattedDate}`;
  },
  getPersistedFilters: function(){
    var filters = getCookie(this.state.persistedFiltersCookieName) || "{}";
    return JSON.parse(filters);
  },
  getPersistedOrderByValue: function(){
    var orderBy = this.getPersistedOrderByCookie();
    var orderByValue = this.state.orderBy.value;

    if(this.state.subEnv=="deal"||this.state.subEnv=="person") {
      orderByValue = orderBy[this.state.subEnv];
    } else {
      orderByValue = orderBy[this.state.env];
    }

    return orderByValue;
  },
  getPersistedOrderByCookie: function(){
    var orderBy = getCookie(this.state.persistedOrderByCookieName) || "{}";
    orderBy = JSON.parse(orderBy);
    return orderBy;
  },
  persistFilter: function(filter){
    var filters = this.getPersistedFilters();
    if(!filters[this.state.env]) {
      filters[this.state.env] = {};
    }
    filters[this.state.env][filter.name] = filter;
    var value = JSON.stringify(filters);
    setCookie(this.state.persistedFiltersCookieName,value,this.state.daysToPersistCookies);
  },
  onApplyFilter: function(filter, updateListing){
    var isMoreFilter = _.contains(MORE_FILTERS, filter.name);

    if (isMoreFilter) {
      this.handleMoreFiltersCounter(this.state.filterValues, filter.name);
    }

    if (filter.value === "") {
      this.state.filterValues[filter.name].value = "";
    } else {
      this.state.filterValues[filter.name] = filter;
    }

    this.handleDealStatusChange(filter);
    this.persistFilter(filter);
    this.setState(this.state);

    if (typeof(updateListing) == "undefined" || updateListing == true) {
      this.updateListing();
    }
  },
  handleDealStatusChange: function(filter) {
    var isFilteringByDealStatus = filter.name == "sn";
    var isDealStatusLost = filter.value == 3;
    if (isFilteringByDealStatus && !isDealStatusLost) {
      this.state.filterValues["mp"].value = "";
      this.persistFilter(this.state.filterValues["mp"]);
    }
  },
  handleMoreFiltersCounter: function(filters, selectedFilterName) {
    var isFilterValueDefined = this.state.filterValues[selectedFilterName].hasOwnProperty("value");

    if (isFilterValueDefined) {
      if (this.state.filterValues[selectedFilterName].value.length == 0) {
        this.updateMoreFilters();
      }
    } else {
      this.updateMoreFilters();
    }
  },
  updateMoreFilters: function() {
    this.state.filterValues.moreFilters.quantity += 1;
    this.state.filterValues.moreFilters.opened = true;

    this.persistFilter(this.state.filterValues["moreFilters"]);
    this.setState(this.state);
  },
  // Overridden filters must be removed from persistence because they are not saved in the session.
  // Maintaining them should cause divergence between the filters displayed and those actually applied.
  onHandleFilterOverrides: function (filters) {
    for (var key in filters) {
      this.persistFilter({name: key});
    }
  },
  onRemoveAllFilters: function(){
    $(document).trigger("ListingFilter.removeAllFilters");

    var state = jQuery.extend({},this.state);

    for (var key in state.filterValues) {
      if (state.filterValues.hasOwnProperty(key)) {
        var filter = state.filterValues[key];

        if (filter.preventRemoval) continue;

        switch (key) {
          case "moreFilters":
            filter.quantity = 0;
            filter.opened = false;
            filter.highlighted = false;

            break;

          default:
            filter.value = "";
        }
      }
    }

    this.removeAllCurrentEnvFilters();
    this.setState(state);
    this.updateListing();
  },
  removeAllCurrentEnvFilters: function(){
    var filters = this.getPersistedFilters();
    filters[this.state.env] = {};
    var value = JSON.stringify(filters);
    setCookie(this.state.persistedFiltersCookieName,value,this.state.daysToPersistCookies);
  },
  onRemoveFilter: function(filter, updateListing){
    $(document).trigger("ListingFilter.removeFilter", {filter:filter, updateListing:updateListing});

    var isMoreFilter = _.contains(MORE_FILTERS, filter.name);

    if (isMoreFilter) {
      this.state.filterValues.moreFilters.quantity -= 1;
      if (this.state.filterValues.moreFilters.quantity == 0) {
        this.state.filterValues.moreFilters.highlighted = false;
      }
    }

    var isProduct = (filter.name.indexOf("pro") >= 0);

    if (isProduct) {
      var currentProductSelection = this.state.filterValues["pro"].value;
      var currentProductSelectionArray = currentProductSelection.split(",");
      var removedProductId = filter.name.split('pro').join('');
      var removedProductArray = _.without(currentProductSelectionArray, removedProductId);

      this.state.filterValues['pro'].value = removedProductArray.join(",");
    }

    this.state.filterValues[filter.name].value = "";

    this.persistFilter({name:filter.name});
    this.setState(this.state);
    if (typeof(updateListing) == "undefined" || updateListing == true) {
      this.updateListing();
    }
  },
  onOrderBy: function(value){
    var orderBy = this.getPersistedOrderByCookie();
    if (this.state.subEnv == "deal" || this.state.subEnv == "person") {
      orderBy[this.state.subEnv] = value;
    } else {
      orderBy[this.state.env] = value;
    }
    this.state.orderBy.value = value;

    setCookie(this.state.persistedOrderByCookieName,JSON.stringify(orderBy),this.state.daysToPersistCookies);

    this.setState(this.state);
    this.updateListing();
  },
  onUpdateTotalResults: function(value){
    this.state.totalResults = value;
    this.setState(this.state);
  },
  onUpdateDealsTotalValue: function(value){
    this.state.dealsTotalValue = value;
    this.setState(this.state);
  },
  onHighlightFilter: function(filterName){
    this.state.filterValues[filterName].highlight = true;
    this.setState(this.state);
  },
  onUpdatePage: function(value){
    this.state.pg = value;
    this.setState(this.state);
  },
  onDiminishFilters: function(filterName){
    for (var key in this.state.filterValues) {
        this.state.filterValues[key].highlight = false;
    }
    this.setState(this.state);
  },
  onLoadSelectOptionsCompleted: function(data){
    var select = this.state.selects[data.name];
    var options = select.options;

    if(select.extraOptions) {
      options = options.concat(select.extraOptions);
    }
    options = options.concat(data.options);

    select.options = options;

    this.setState(this.state);
  },
  onLoadUserOwnerOptionsCompleted: function(data) {
    if (data.options && data.options.length > 0) {
      var userOwners = _.map(data.options, function(user) {
        if (LOGGED_USER_ID == user.id || user.active === undefined) {
          return;
        }
        return {id: user.id, name: user.name, group: (user.active ? "active" : "inactive")};
      });

      var userSelect = this.state.selects[data.name];

      userOwners = _.compact(userOwners);
      userOwners = _.sortBy(userOwners, "name");

      userOwners.splice(0, 0, {id: "", name: "Responsável", group: "nogroup"},
                              {id: LOGGED_USER_ID, name: "Eu", group: "nogroup"},
                              {id: "-1", name: "Indefinido", group: "nogroup"});

      userSelect.options = userOwners;

      this.setState(this.state);
    }
  },
  onLoadFunnelOptionsCompleted: function(data) {
    if (data.options && data.options.length > 0) {
      var select = this.state.selects[data.name];
      var options = select.options;

      options = options.concat(data.options);

      select.options = options;

      this.setState(this.state);
    }
  },
  onLoadDealStageOptionsCompleted: function(data) {
    if (data.options && data.options.length > 0) {
      let groups = [];
      let dealStages = [];

      let onlyDefaults = this.state.subEnv != null;

      _.each(data.options, function(stage) {
        if(onlyDefaults && !stage.funnel.default) return;

        groups.push({
          id: stage.funnel.id,
          name: stage.funnel.name,
          order: stage.funnel.order
        });

        dealStages.push({
          id: stage.id,
          name: stage.name,
          group: stage.funnel.id
        });
      });

      let unifiedGroups = _.uniq(groups, function(group) { return group.id; });
      let stageGroups = _.sortBy(unifiedGroups, "order");

      stageGroups.splice(0, 0, { id: "nogroup", name: "" });

      dealStages.splice(0, 0, { id: "", name: "Etapa", group: "nogroup" },
                              { id: "-1", name: "Indefinida", group: "nogroup"});

      let dealStageSelect = this.state.selects[data.name];
      dealStageSelect.options = dealStages;
      dealStageSelect.groups = stageGroups;

      this.setState(this.state);
    }
  },
  onLoadLeadOriginOptionsCompleted: function(data) {
    if (data.options && data.options.length > 0) {

      var leadOrigins = _.compact(data.options);
      leadOrigins = _.sortBy(leadOrigins, "name");

      var leadOriginSelect = this.state.selects[data.name];

      leadOrigins.splice(0, 0, {id: "", name: "Origem"},
                              {id: "-1", name: "Indefinida"});

      leadOriginSelect.options = leadOrigins;

      this.setState(this.state);
    }
  },
  onLoadProductsCompleted: function(data) {
    this.state.filterValues.pro.data = data;
    this.setState(this.state);
  },
  onLoadQuoteCompleted: function(quote){
    this.state.inspirationalQuote = quote;
    this.setState(this.state);
  },
  onMoreFiltersClick: function() {
    var hasMoreFilter = this.state.filterValues.moreFilters.quantity > 0;
    var isClosed = !this.state.filterValues.moreFilters.opened;

    if (hasMoreFilter || isClosed) {
      this.state.filterValues.moreFilters.highlighted = true;
    } else {
      this.state.filterValues.moreFilters.highlighted = false;
    }

    this.state.filterValues.moreFilters.opened = !this.state.filterValues.moreFilters.opened;

    this.persistFilter(this.state.filterValues["moreFilters"]);
    this.setState(this.state);
  }
});

module.exports = ListingStore;



// WEBPACK FOOTER //
// ./app/shared/stores/listing-store.js